import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var VideosSvg = function VideosSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6356F6",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m9.962 16.203 5.164-3.443a.833.833 0 0 0 0-1.387L9.962 7.93a.833.833 0 0 0-1.296.693v6.886a.833.833 0 0 0 1.296.694",
    clipRule: "evenodd"
  }));
};
export var Videos = function Videos(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: VideosSvg
  }));
};